// import data from './structured_client_data.json';

export const getApp = async (exhibitId: string) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_API_URL +
        "organization/getApp?exhibitId=" +
        exhibitId,
      { method: "GET" }
    );

    if (!response.ok) {
      throw new Error(response.statusText || "Failed to fetch data");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch error:", error);
  }
};
